module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-23.7b31e986.jpg";